import React from "react";
import { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
// import classnames from 'classnames';

const CollectDocs = (props) => {
  const [paperOrders, setPaperOrders] = useState([]);
  const [updateDocTable, setUpdateDocTable] = useState(false);
  const [collectedDocs, setCollectedDocs] = useState([]);
  const [docProblemtextareaValue, setDocProblemtextareaValue] = useState();
  const [docproblemInvoiceId, setDocProblemInvoiceId] = useState(0);
  const [docmultipleorderIds, setdocMultipleorderIds] = useState([]);

  //start of docAlertModal realated states and function
  const [docalertModal, setdocAlertModal] = useState(false);
  const docalertToggle = () => setdocAlertModal(!docalertModal);

  //start of Modal realated states and function
  const {
    // buttonLabel,
    className,
  } = props;

  const [docProblemmodal, setDocProblemmodal] = useState(false);
  const docProblemtoggle = () => setDocProblemmodal(!docProblemmodal);

  const [PmodalDocProblemList, setPmodalDocProblemList] = useState([]);
  const [docpProblemDetailInvoiceId, setdocpProblemDetailInvoiceId] =
    useState();
  const [boxPupdateTriger, setPUpdateTriger] = useState(false);

  const [docPmodal, setDocPModal] = useState(false);
  const boxtoggleP = () => setDocPModal(!docPmodal);

  const docProblemsdetailsHandler = (data) => {
    // for (let i = 1; i <= data.problems.length; i++) {
    //      element.push(data.problems[i]);
    //     setmodalProblemList(element)
    // }
    setPmodalDocProblemList(data.problems);
    setdocpProblemDetailInvoiceId(data.invoiceId);
  };

  const docsolvePHandler = (problem, problemId, problemDesc, index) => {
    const ProblemSolved = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${docpProblemDetailInvoiceId}/${problemId}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              solved: true,
              Description: problemDesc,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setPUpdateTriger(!boxPupdateTriger);
          let toRemove = problem;
          let index = PmodalDocProblemList.indexOf(toRemove);
          if (index > -1) {
            //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
            PmodalDocProblemList.splice(index, 1);
            // if (index === 0) {
            //   boxtoggleP()
            // }
            //   if (!problem.hasProblem) {
            //     boxtoggleP()
            // }
          }
          let counterOfProblem = 0;
          PmodalDocProblemList.forEach(function (arraItem) {
            // Expected '===' and instead saw '=='
            if (arraItem.solved === false) {
              ++counterOfProblem;
            }
          });
          if (counterOfProblem < 1) {
            boxtoggleP();
          }
          // console.log(PmodalDocProblemList);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    ProblemSolved();
  };

  const fetchPaperApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/papersToCollect/${props.dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setPaperOrders(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const docProblemInvoiceIdHandler = (invoiceID) => {
    setDocProblemInvoiceId(invoiceID);
  };

  const docProblemHandler = async (e) => {
    // e.preventDefault()
    if (docProblemtextareaValue !== null) {
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${docproblemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: docProblemtextareaValue,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateDocTable(!updateDocTable);
          setDocProblemtextareaValue(null)
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error "+ response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    }
  };

  const handleDocTextareaChange = (event) => {
    setDocProblemtextareaValue(event.target.value);
  };

  const docCollectedOkHandler = (invoice, data) => {
    if (data.invoiceIdsInOrder.length > 1) {
      // alert("this order has more than 1 item. \n" + " " + "it contains following order ids: \n" + data.invoiceIdsInOrder);
      setdocMultipleorderIds(data.watchIdsInOrder);
      docalertToggle();
    }
    const docCollectedPost = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/status/${invoice}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              StatusName: "paperscollected",
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateDocTable(!updateDocTable);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    docCollectedPost();
  };

  const fetchDocPhisicallyCollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/paperscollected/${props.dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setCollectedDocs(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchPaperApi();
    fetchDocPhisicallyCollectedApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    updateDocTable,
    props.dropdown,
    props.watchCollectProblem,
    boxPupdateTriger,
  ]);
  return (
    <Row>
      <Col sm="12">
        <div>
          <p>
            Noch abzuholen: <strong>{paperOrders.length}</strong> Dokumente von{" "}
            {paperOrders.length + collectedDocs.length}
          </p>
          <Table bordered striped hover>
            <thead>
              <tr>
                <th>Lagerort</th>
                <th>Digits</th>
                <th>Auftrag</th>
                <th>Bezeichnung</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {paperOrders.map((data, index) => {
                return (
                  <tr key={index}>
                    <th scope="row">{data.locationOfPapers}</th>
                    <td>
                      {data.statusDbDigit}{" "}
                      {data.hasProblem ? (
                        <i
                          onClick={() => {
                            boxtoggleP();
                            docProblemsdetailsHandler(data);
                          }}
                          id="problem"
                          className="fas fa-exclamation-circle"
                        ></i>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{data.orderId}</td>
                    <td>{data.saleTitle}</td>
                    <td
                      style={
                        data.invoiceIdsInOrder.length > 1
                          ? { backgroundColor: "#ffc107" }
                          : {}
                      }
                    >
                      <div
                        className="displayFlex"
                        style={{ justifyContent: "space-around" }}
                      >
                        <Button
                          color="primary"
                          onClick={() => {
                            docCollectedOkHandler(data.invoiceId, data);
                          }}
                        >
                          OK
                        </Button>{" "}
                        <div>
                          <Button
                            color="danger"
                            className="ml-3"
                            onClick={() => {
                              docProblemtoggle();
                              setDocProblemtextareaValue(null);
                              docProblemInvoiceIdHandler(data.invoiceId);
                            }}
                          >
                            Problem
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tbody>
              {collectedDocs.length > 0 && (
                <tr className="tbodyDivider">
                  <th colSpan="5">
                    Eingesammelt: {collectedDocs.length} Documents
                  </th>
                </tr>
              )}
              {collectedDocs.map((collectedDoc, i) => {
                return (
                  <tr
                    key={-i}
                    style={{
                      backgroundColor: "#00FA9A	",
                      color: "#212529",
                      opacity: "0.8",
                    }}
                  >
                    <th scope="row">{collectedDoc.locationOfPapers}</th>
                    <td>
                      {collectedDoc.statusDbDigit}{" "}
                      {collectedDoc.hasProblem ? (
                        <i
                          id="problem"
                          className="fas fa-exclamation-circle"
                        ></i>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{collectedDoc.orderId}</td>
                    <td>{collectedDoc.saleTitle}</td>
                    <td
                      style={
                        collectedDoc.invoiceIdsInOrder.length > 1
                          ? { backgroundColor: "#ffc107" }
                          : {}
                      }
                    ></td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Col>
      <Modal
        size="lg"
        centered={true}
        isOpen={docProblemmodal}
        toggle={docProblemtoggle}
        className={className}
      >
        <ModalHeader toggle={docProblemtoggle}>Problem melden</ModalHeader>
        <ModalBody>
          <textarea
            style={{ width: "100%", height: "100px" }}
            onChange={handleDocTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              docProblemHandler();
              docProblemtoggle();
            }}
          >
            Problem speichern
          </Button>{" "}
          <Button color="secondary" onClick={docProblemtoggle}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={docalertModal}
        centered={true}
        toggle={docalertToggle}
        className={className}
      >
        <ModalHeader toggle={docalertToggle}>
          Achtung! Auftrag enthält mehrere Bestellungen.
        </ModalHeader>
        <ModalBody>
          <p>
            Dieser Auftrag beinhaltet mehrere Bestellungen. Bitte Dokumente aus
            dem Auftrag gemeinsam einsortieren.
            <br />
            Interne Nummern in diesem Auftrag:
          </p>
          {
            <ul>
              {docmultipleorderIds.map((txt, index) => (
                <li key={index}>
                  <b>{txt}</b>
                </li>
              ))}
            </ul>
          }
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            style={{ color: "#212529" }}
            onClick={docalertToggle}
          >
            OK
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={docPmodal}
        toggle={boxtoggleP}
        className={className}
      >
        <ModalHeader toggle={boxtoggleP}>Problemdetails</ModalHeader>
        <ModalBody>
          <div>
            <ol
              style={{ maxHeight: "300px", overflow: "auto", paddingLeft: "0" }}
            >
              {PmodalDocProblemList.map((problem, index) => {
                if (!problem.solved) {
                  return (
                    <div
                      key={index}
                      // style={ (solvedClicked && solvedClickedIndex === index) ? { display: "none"} : {}}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          marginRight: "10px",
                        }}
                      >
                        <p>
                          <span style={{ paddingRight: "16px" }}>
                            <b>{problem.personName}:</b>
                          </span>
                          {problem.description}
                        </p>
                        {/* {modalProblemList} */}
                        <Button
                          color="success"
                          className="ml-3"
                          onClick={() => {
                            docsolvePHandler(
                              problem,
                              problem.id,
                              problem.description,
                              index
                            );
                          }}
                        >
                          Problem gelöst
                        </Button>
                      </li>
                      <hr></hr>
                    </div>
                  );
                }
                return null;
              })}
            </ol>
          </div>
          {/* <textarea style={{ width: '100%', height: '100px' }} placeholder="In case of new problem, please write your comment here"
                        onChange={handleProblemTextareaChange}
                        autoFocus={true} ></textarea> */}
        </ModalBody>
        {/* <ModalFooter style={{ justifyContent: "space-between" }}>
                    <Button color="primary" onClick={() => { updateProblemHandler(); boxtoggleP() }}>Update the problem</Button>{' '}
                    <Button color="danger" onClick={() => {cancelHandler(); boxtoggleP();}}>Cancel item</Button>
                    <Button color="secondary" onClick={boxtoggleP}>Close</Button>
                </ModalFooter> */}
      </Modal>
    </Row>
  );
};

export default CollectDocs;
